import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button, withTranslation } from '../../../common';
import '../_style.css';

function NewResourcesSubTypesButton({ translate, history }) {
  const redirect = () => {
    history.push('/admin/settings/resourcesSubTypes/create');
  };

  return (
    <Button
      icon="054-new"
      label={translate('admin.settings.resourcesSubTypes.new')}
      onClick={redirect} />
  );
}

NewResourcesSubTypesButton.propTypes = {
  translate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withTranslation(withRouter(NewResourcesSubTypesButton));
